import { useMutation } from '@tanstack/react-query';
import { createSupportRequest } from './api';

export function useCreateSupportRequest() {
  return useMutation({
    mutationFn: createSupportRequest,
  });
}
